import { useQuery } from "@tanstack/react-query";

import type { CosignatureQueueResponse, CosignatureStatusParam } from "@/core/types";
import { CosignatureStatusEnum } from "@/core/constants";

import { optionFactory as cosignatureQueueOptionFactory } from "./useCosignatureQueue";

export const DEFAULT_NEEDS_REVIEW_STATUS =
  `${CosignatureStatusEnum.PENDING},${CosignatureStatusEnum.RESUBMITTED}` as CosignatureStatusParam;

type UseNeedsReviewQueueProps<TData = CosignatureQueueResponse> = {
  cosignature_status?: CosignatureStatusParam;
  enabled?: boolean;
  page_size?: number;
  select?: (data: CosignatureQueueResponse) => TData;
  start_key?: string;
  supervisor_id?: string;
};

function optionFactory(
  {
    cosignature_status,
    page_size,
    start_key,
    supervisor_id,
  }: Omit<UseNeedsReviewQueueProps, "select" | "enabled"> = {},
  enabled = true,
) {
  return cosignatureQueueOptionFactory(
    {
      cosignature_status: cosignature_status ?? DEFAULT_NEEDS_REVIEW_STATUS,
      page_size,
      start_key,
      supervisor_id,
    },
    enabled,
  );
}

export function useNeedsReviewQueue<TData = CosignatureQueueResponse>({
  cosignature_status,
  enabled,
  page_size,
  select,
  start_key,
  supervisor_id,
}: UseNeedsReviewQueueProps<TData> = {}) {
  return useQuery({
    ...optionFactory({ cosignature_status, page_size, start_key, supervisor_id }, enabled),
    keepPreviousData: true,
    select,
  });
}
